<template>
    <div style="position:fixed; bottom:164px; right: 34px; z-index: 9999;">
        <img src="/media/logo-dau-an.svg" alt="logo-zalo" @click="openDauAn" class="bounce-animation" style="width: 45px; height: 45px">
        <el-dialog
            custom-class="fit-dialog"
            :visible.sync="isShow"
            :show-close="false"
            @close="closeDialog"
        >
            <div
                class="tixScreen"
                :class="bgTicket"
            >
                <transition name="tix-swap" mode="out-in">
                    <section key="after" class="tixAfter" :class="infoChair.chair.name.toLowerCase()">
                        <div class="tixBanner text-center ">DẤU ẤN <br> EDUTALK 2025</div>
                        <article class="tixConfirm">
                            <div class="tixConfirm__name">{{ currentUser.name ?? '' }}</div>
                            <div class="tixConfirm__role">{{ currentUser.role ?? '' }}</div>

                            <div class="tixConfirm__line">
                                Hạng vé của bạn: <b class="uppercase text-32">{{ infoChair.chair.name ?? '' }}</b>
                            </div>

                            <div class="tixConfirm__meta">
                                <div>Thời gian: <b>{{ eventTime }}</b></div>
                                <div>Địa điểm: <b>{{ eventLocation }}</b></div>
                            </div>
                            <div id="qr-personal">
                                <qr-code style="width: 100%" :text="qrcode"></qr-code>
                            </div>
                        </article>
                        <img style="opacity: 35%;" class="logo-dau-an-ticket" src="/media/logo-dau-an.svg" alt="">
                    </section>
                </transition>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import { SHOW_CHAIR_BY_USER, USER_GET_QR_CODE } from "@/core/services/store/user/users.module";

export default {
    components: {},
    data() {
        return {
            isShow: false,
            eventTime: '1/2/2026',
            disableCancel: false,
            eventLocation: 'Hội trường Khách sạn Mường Thanh Linh Đàm',
            infoChair: null,
            qrcode: null,
        }
    },
    computed: {
        bgTicket() {
            const n = (this.infoChair?.chair?.name).toLowerCase()
            if (n === 'ruby') return 'ticket--ruby'
            if (n === 'diamond') return 'ticket--diamond'
            if (n === 'gold') return 'ticket--gold'
            if (n === 'silver') return 'ticket--silver'
            return 'ticket--member'
        },
        ...mapGetters(['currentUser'])
    },
    methods: {
        openDauAn() {
            this.isShow = true
        },
        fetchQRCode() {
            this.loading = true
            this.$store.dispatch(USER_GET_QR_CODE)
                .then((response) => {
                    this.qrcode = response.data
                })
                .catch((error) => {
                })
                .finally(() => {
                    this.loading = false
                })
        },
        isShowDialog() {
            const defaultDates = ['27/01', '28/01', '29/01', '30/01', '31/01', '01/02', '02/02'];
            const today = moment().tz("Asia/Ho_Chi_Minh").format("DD/MM");
            this.isShow = defaultDates.includes(today) && localStorage.getItem('signature') === '1';
        },
        getChairByUser() {
            this.$store.dispatch(SHOW_CHAIR_BY_USER).then((res) => {
                if (res.data) {
                    this.infoChair = res.data;
                    this.isShowDialog()
                } else {
                    this.$router.push('/dang-ky-dau-an');
                }
            })
        },
        closeDialog() {
            this.isShow = false
            localStorage.setItem('signature', '-1')
        },
        checkLocalStorage() {
            const signature = localStorage.getItem('signature')
            if (signature !== '1') {
                localStorage.setItem('signature', '1')
            }
        }
    },
    mounted() {
        this.fetchQRCode();
        this.checkLocalStorage();
        this.getChairByUser();
        this.disableCancel = this.$moment() <= this.$moment('2026-02-01 00:00:00')
    }
}
</script>

<style>
#qr-personal div {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
#qr-personal img{
    width: 100px !important;
    height: 100px !important;
}
.bounce-animation {
    cursor: pointer;
    animation: bounce 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.fit-dialog.el-dialog {
    width: max-content !important;
    background: transparent;
    border: 0 !important;
    box-shadow: none !important;
}

.dau-an {
    display: flex;
}

.text-32 {
    font-size: 28px;
}

.tixScreen{
    border-radius: 15px;
    width: 400px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    padding: 50px 20px;
    justify-content: center;
}

.member .tixOption__value.dau-an .slot {
    font-size: 12px;
    background: #E8E8EA;
    padding: 2px 4px 0;
    color: #808080;
    border-radius: 2px;
}

.tixAfter{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.tixBanner{
    margin-top: 12px;
    align-self: center;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .10em;
    font-size: 34px;
    text-shadow: 0 1px 0 rgba(255,255,255,.35);
}
.member .tixBanner { color: white; }
.gold .tixBanner { color: #34221A; }
.ruby .tixBanner { color: white; }
.ruby .tixConfirm__line b { color: #A10014; }
.diamond .tixConfirm__line b { color: #2EA6FF; }
.member .tixConfirm__line b { color: #683EA0; }
.diamond .tixBanner { color: #414042; }

.tixConfirm{
    margin-top: 12px;
    border-radius: 18px;
    background: rgba(255,255,255,.92);
    border: 1px solid rgba(17,24,39,.10);
    box-shadow: 0 12px 26px rgba(0,0,0,.16);
    padding: 16px;
}

.tixConfirm__name{
    font-size: 30px;
    font-weight: 900;
    color: rgba(17,24,39,.94);
}

.tixConfirm__role{
    margin-top: 4px;
    font-size: clamp(12px, 1.4vw, 14px);
    color: rgba(17,24,39,.70);
}

.tixConfirm__line{
    margin-top: 10px;
    font-size: clamp(13px, 1.6vw, 15px);
    color: rgba(17,24,39,.84);
}

.tixConfirm__line b{
    font-weight: 900;
    letter-spacing: .02em;
}

.tixConfirm__meta{
    margin-top: 14px;
    font-size: clamp(12px, 1.4vw, 14px);
    color: rgba(17,24,39,.78);
    line-height: 1.5;
}

.tixConfirm__actions{
    margin-top: 16px;
}
.logo-dau-an-ticket {
    width: 50%;
    margin: 30px auto 0;
}

.tixScreen {
    min-height: 600px;
}
.ticket--ruby { background-image: url("/media/ruby.png"); }
.ticket--diamond { background-image: url("/media/diamond.png"); }
.ticket--gold { background-image: url("/media/gold.png"); }
.ticket--silver { background-image: url("/media/silver.png"); }
.ticket--member { background-image: url("/media/member.png"); }

.ticket--diamond .tixOption__cta button { color: white ; border-radius: 4px; background-color: #0181d0; border-color: #0181d0 }
.ticket--ruby .tixOption__cta button { color: white ; border-radius: 4px; background-color: #7b020d; border-color: #b1121b }
.ticket--silver .tixOption__cta button { color: white ; border-radius: 4px; background-color: #31827B; border-color: #31827B }
.ticket--member .tixOption__cta button { color: white ; border-radius: 4px; background-color: #5B3795; border-color: #5B3795 }
.uppercase { text-transform: uppercase }
@media (max-width: 768px){
    .tixScreen{
        width: 360px;
    }
}
</style>
